/**
 * Update General Settings Use Case
 * Updates DCS App configuration
 */

import { GeneralSettingsRepository } from '../data/general-settings-repository';
import { DcsApp } from '../types/general-settings-types';

export class UpdateGeneralSettingsUseCase {
  constructor(private repository: GeneralSettingsRepository) {}

  /**
   * Execute: Update general settings
   * @param app - Updated app settings
   * @param originalApp - Original app settings (for delta calculation)
   * @returns Promise<void>
   */
  async execute(app: DcsApp, originalApp: DcsApp): Promise<void> {
    console.log('[UpdateGeneralSettingsUseCase] Executing for app:', app.appId);

    try {
      await this.repository.updateSettings(app, originalApp);

      console.log('[UpdateGeneralSettingsUseCase] Success:', {
        appId: app.appId
      });
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : String(error);
      console.error('[UpdateGeneralSettingsUseCase] Failed:', errorMessage);
      throw error;
    }
  }
}
